import request from '@/utils/request'

/** 获取系统配置（含 privacyMobileMask 手机号脱敏开关） */
export function getSystemConfig() {
  return request({
    url: '/api/system/SysConfig',
    method: 'GET'
  })
}
